import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CKAuthService } from '@ck-core/ck-auth';
import { SiteContextService } from '../services/site-context.service';

import { environment } from '../../../environments/environment';

export const siteHeaderInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(CKAuthService);
    const siteContextService = inject(SiteContextService);

    let headers = req.headers;

    // Retrieve siteId and tenantId from context and auth data, fallback to environment
    let siteId = siteContextService.siteId || environment.siteId;
    let tenantId = authService.authData?.moreInfo?.tenantId || environment.tenantId;

    // Support URL overrides (e.g., for standalone PDF view)
    const urlParams = new URLSearchParams(window.location.search);
    const urlTenantId = urlParams.get('tenantId');
    const urlSiteId = urlParams.get('siteId');

    if (urlTenantId) {
        tenantId = urlTenantId;
    }

    if (urlSiteId) {
        siteId = urlSiteId;
    }

    if (siteId && !headers.has('site-id')) {
        headers = headers.set('site-id', siteId);
    }

    if (tenantId && !headers.has('x-tenant-id')) {
        headers = headers.set('x-tenant-id', tenantId);
    }

    const clonedRequest = req.clone({ headers });

    return next(clonedRequest);
};
